export function CollectionCardFooter({
	childCourseCount,
	countLabel,
}: {
	childCourseCount?: number | null
	countLabel?: string | null
}) {
	if (
		(typeof childCourseCount !== 'number' || childCourseCount <= 0) &&
		!countLabel
	) {
		return null
	}

	const visibleDots =
		typeof childCourseCount === 'number' && childCourseCount > 0
			? Math.min(childCourseCount, 6)
			: 0

	return (
		<div className="flex items-center justify-between gap-3">
			<div aria-hidden="true" className="flex min-w-0 items-center gap-1.5">
				{Array.from({ length: visibleDots }, (_, index) => (
					<span
						key={index}
						className="bg-foreground/18 inline-block h-2 w-2 rounded-full"
					/>
				))}
			</div>
			{countLabel ? (
				<span className="text-muted-foreground shrink-0 text-[11px] font-medium tracking-[0.01em]">
					{countLabel}
				</span>
			) : null}
		</div>
	)
}
